import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import SEO from "@/components/SEO";
import PageHero from "@/components/site/PageHero";
import Reveal from "@/components/site/Reveal";
import { ContactCTA } from "@/pages/Home";
import { MapPin, Briefcase, Clock, ArrowUpRight } from "lucide-react";

const PERKS = [
  "Fully remote-first culture", "Competitive salary & equity", "Learning & conference budget",
  "Top-tier equipment", "Flexible time off", "Quarterly team retreats",
];

export default function Careers() {
  const [jobs, setJobs] = useState([]);
  useEffect(() => {
    api.get("/careers").then((r) => setJobs(r.data)).catch(() => {});
  }, []);

  return (
    <>
      <SEO title="Careers" description="Join Web Vantage Enterprises. We're hiring designers, engineers and growth specialists who obsess over craft." path="/careers" />
      <PageHero
        overline="Careers"
        title="Do the best work of your life"
        subtitle="We're a team of makers who care deeply about craft and outcomes. If that sounds like you, we'd love to talk."
        crumbs={[{ label: "Careers" }]}
      />
      <section className="py-20 lg:py-28">
        <div className="container-wv grid gap-12 lg:grid-cols-[1.4fr_1fr]">
          <div>
            <h2 className="font-heading text-2xl font-semibold text-white">Open positions</h2>
            <div className="mt-8 space-y-4">
              {jobs.map((job, i) => (
                <Reveal key={job.id} delay={i * 0.06} className="group rounded-3xl border border-white/10 bg-white/[0.03] p-6 transition-colors hover:border-vantage/40">
                  <div className="flex flex-col justify-between gap-4 sm:flex-row sm:items-center">
                    <div>
                      <h3 className="font-heading text-xl font-semibold text-white">{job.title}</h3>
                      <div className="mt-3 flex flex-wrap gap-4 text-xs text-slate-400">
                        <span className="inline-flex items-center gap-1.5"><Briefcase className="h-4 w-4" /> {job.department}</span>
                        <span className="inline-flex items-center gap-1.5"><MapPin className="h-4 w-4" /> {job.location}</span>
                        <span className="inline-flex items-center gap-1.5"><Clock className="h-4 w-4" /> {job.type}</span>
                      </div>
                    </div>
                    <Link to="/contact" className="btn-ghost shrink-0" data-testid={`apply-${job.slug}`}>
                      Apply <ArrowUpRight className="h-4 w-4" />
                    </Link>
                  </div>
                  <p className="mt-4 text-sm leading-relaxed text-slate-400">{job.description}</p>
                </Reveal>
              ))}
              {jobs.length === 0 && (
                <p className="rounded-3xl border border-white/10 bg-white/[0.03] p-8 text-slate-400">
                  No open roles right now — but we're always meeting great people. Send us a note via the contact page.
                </p>
              )}
            </div>
          </div>
          <Reveal delay={0.1} className="h-fit rounded-3xl border border-white/10 bg-white/[0.03] p-8">
            <h3 className="font-heading text-xl font-semibold text-white">Why you'll love it here</h3>
            <ul className="mt-6 space-y-3">
              {PERKS.map((p) => (
                <li key={p} className="flex items-center gap-3 text-sm text-slate-300">
                  <span className="h-1.5 w-1.5 rounded-full bg-vantage" /> {p}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </section>
      <ContactCTA />
    </>
  );
}
